import React, { createContext, useState, useContext } from "react";
import { getAccessToken } from "../services/tokenService";
import { logout as logoutService } from "../services/authService";


const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [showLogin, setShowLogin] = useState(false);
  const isAuthenticated = !!getAccessToken();

  const login = (userData) => {
    // you’ll call your real login API here and persist token
    setShowLogin(false);
  };

  const logout = () => {
    logoutService();
    window.location.reload();  // or better: reset auth state
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, showLogin, setShowLogin, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
}

// custom hook for ease of use:
export const useAuth = () => useContext(AuthContext);
